type Props = {
  onClick: () => void;
  text: string;
};

export default function TextButton({ onClick, text }: Props) {
  return (
    <button
      type="button"
      className="cursor-pointer rounded text-left text-sm underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary lg:text-[17px]"
      onClick={onClick}
    >
      {text}
    </button>
  );
}
